import { render, staticRenderFns } from "./DownChevronIcon.vue?vue&type=template&id=565dc33f&"
import script from "./DownChevronIcon.vue?vue&type=script&lang=js&"
export * from "./DownChevronIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports